module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_5012.e644e438.png";